import React from "react";

// Tells the user where the OTP actually went, when it wasn't WhatsApp.
//
// The backend tries WhatsApp -> SMS -> registered email and reports which rung
// succeeded. On the happy path this renders nothing: the OTP screen already
// implies WhatsApp, and a banner confirming the expected thing is just noise.
// It only speaks up when the channel changed — which is exactly the case where
// the user would otherwise stare at an empty WhatsApp thread and give up.
//
// A toast can't do this job: it's gone in a few seconds, while the question
// ("why hasn't it arrived?") occurs a minute later. So this sits inline, above
// the OTP inputs, for as long as the screen is open.
export default function OtpChannelNotice({
  channel,
  sentTo,
  className = "",
}: {
  channel: string | null;
  sentTo: string | null;
  className?: string;
}) {
  if (!channel || channel === "whatsapp") return null;

  const isEmail = channel === "email";

  return (
    <div
      role="status"
      className={`mb-[14px] rounded-[8px] border px-[14px] py-[10px] font-LatinkaRegular text-[13px] leading-[150%] ${
        isEmail
          ? "border-[#FFD9A0] bg-[#FFF4E5] text-[#8A5A00]"
          : "border-[#BBCBF2] bg-[#EAF2FF] text-[#1B4FD1]"
      } ${className}`}
    >
      {isEmail ? (
        <>
          We couldn&apos;t deliver the OTP to your mobile, so it has been sent to your
          registered email {sentTo ? <strong>{sentTo}</strong> : "address"} instead.
        </>
      ) : (
        <>
          WhatsApp couldn&apos;t be reached, so your OTP was sent by SMS
          {sentTo ? (
            <>
              {" "}
              to <strong>{sentTo}</strong>
            </>
          ) : null}
          .
        </>
      )}
    </div>
  );
}
